<script setup lang="ts">
import CategoryCard from "~/components/CategoryCard.vue"
import { useCategoriesStore } from "~/stores/categoriesStore"

/**
 *
 *  Props and emits section
 *
 *
 */

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const router = useRouter()
const route = useRoute()
const categoriesStore = useCategoriesStore()

const categories = [
    {
        name: "Alimentos frescos",
        image: "/img/categories/alimentos-frescos.png",
        searchName: "Alimentos frescos",
    },
    {
        name: "Quesos y mantequillas",
        image: "/img/categories/quesos.png",
        searchName: "Quesos y mantequillas",
    },
    {
        name: "Yogurts y leche",
        image: "/img/categories/yogurts.png",
        searchName: "Yogurts y leche",
    },
    {
        name: "Otros alimentos",
        image: "/img/categories/otros-alimentos.png",
        searchName: "Otros alimentos",
    },
    {
        name: "Panadería y pastelería",
        image: "/img/categories/panaderia.png",
        searchName: "Panadería y pastelería",
    },
    {
        name: "Bebidas",
        image: "/img/categories/bebidas.png",
        searchName: "Bebidas",
    },
    {
        name: "Equipamiento de oficina",
        image: "/img/categories/equipamiento.png",
        searchName: "Equipamiento de oficina",
    },
    {
        name: "Productos del hogar",
        image: "/img/categories/productos-del-hogar.png",
        searchName: "Productos para el Hogar",
    },
    {
        name: "Cuidado personal",
        image: "/img/categories/cuidado-personal.png",
        searchName: "Cuidado personal",
    },
    {
        name: "Combos",
        image: "/img/categories/combos.png",
        searchName: "Combos",
    },
]

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

const searchByCategory = (category: string) => {
    categoriesStore.setCurrentCategorySelected(category)
    router.push({
        path: "/store",
        query: { ...route.query, category: category },
    })
}
</script>

<template>
    <div class="tw-w-full tw-bg-primary">
        <!-- Desktop Version -->
        <div class="tw-hidden md:tw-block tw-py-[120px]">
            <div class="tw-grid tw-grid-cols-10 max-container">
                <CategoryCard
                    class="tw-border-r tw-border-b tw-border-white/20 tw-w-full tw-col-span-2"
                    name="Alimentos frescos"
                    image="/img/categories/alimentos-frescos.png"
                    @click="searchByCategory('Alimentos frescos')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-b tw-border-white/20 tw-w-full tw-col-span-2"
                    name="Quesos y mantequillas"
                    image="/img/categories/quesos.png"
                    @click="searchByCategory('Quesos y mantequillas')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-b tw-border-white/20 tw-col-span-2"
                    name="Yogurts y leche"
                    image="/img/categories/yogurts.png"
                    @click="searchByCategory('Yogurts y leche')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-b tw-border-white/20 tw-col-span-2"
                    name="Panadería y pastelería"
                    image="/img/categories/panaderia.png"
                    @click="searchByCategory('Panadería y pastelería')"
                />
                <CategoryCard
                    class="tw-border-b tw-border-white/20 tw-col-span-2"
                    name="Bebidas"
                    image="/img/categories/bebidas.png"
                    @click="searchByCategory('Bebidas')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-white/20 tw-col-span-2"
                    name="Otros alimentos"
                    image="/img/categories/otros-alimentos.png"
                    @click="searchByCategory('Otros alimentos')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-white/20 tw-col-span-2"
                    name="Equipamiento de oficina"
                    image="/img/categories/equipamiento.png"
                    @click="searchByCategory('Equipamiento de oficina')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-white/20 tw-col-span-2"
                    name="Productos del hogar"
                    image="/img/categories/productos-del-hogar.png"
                    @click="searchByCategory('Productos para el Hogar')"
                />
                <CategoryCard
                    class="tw-border-r tw-border-white/20 tw-col-span-2"
                    name="Cuidado personal"
                    image="/img/categories/cuidado-personal.png"
                    @click="searchByCategory('Cuidado personal')"
                />
                <CategoryCard
                    class="tw-col-span-2"
                    name="Combos"
                    image="/img/categories/combos.png"
                    @click="searchByCategory('Combos')"
                />
            </div>
        </div>

        <!-- Mobile Version -->
        <div class="md:tw-hidden tw-py-2 tw-overflow-hidden">
            <div class="tw-flex tw-gap-0 tw-overflow-x-auto tw-scrollbar-hide">
                <div
                    v-for="(category, index) in categories"
                    :key="index"
                    class="tw-flex-shrink-0 tw-basis-1/4 tw-flex-1 min-[430px]:tw-basis-1/5 tw-flex tw-flex-col tw-gap-1 tw-items-center tw-cursor-pointer category-mobile-item"
                    :class="{
                        'tw-border-r-0': index === categories.length - 1,
                    }"
                    @click="searchByCategory(category.searchName)"
                >
                    <div
                        class="tw-relative tw-flex tw-w-[45px] tw-items-center tw-justify-center"
                    >
                        <!-- Background circle -->
                        <div
                            class="tw-absolute tw-inset-0 tw-bg-white/10 tw-rounded-full"
                        ></div>
                        <img
                            :src="category.image"
                            :alt="category.name"
                            class="tw-relative tw-z-10 tw-w-[45px] tw-h-[48px] tw-object-contain"
                        />
                    </div>
                    <span
                        class="tw-text-white tw-text-[9px] tw-font-bold tw-text-center tw-leading-none tw-font-titilium"
                    >
                        {{ category.name }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.tw-scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.tw-scrollbar-hide::-webkit-scrollbar {
    display: none;
}

.category-mobile-item {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.category-mobile-item.tw-border-r-0 {
    border-right: none;
}
</style>
